module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Titanium + Red Open.e74661a3.png";